import React from 'react';

const AlignerIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M7 21a4.5 4.5 0 0 1-4.2-2.7A4.92 4.92 0 0 1 2 15.5V11a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4.5a4.92 4.92 0 0 1-.8 2.8A4.5 4.5 0 0 1 17 21" />
    <path d="M6.7 15a2.5 2.5 0 0 1 3.4-1.6 2.5 2.5 0 0 1 3.8 0 2.5 2.5 0 0 1 3.4 1.6" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

export default AlignerIcon;
